import React, { useState, useEffect, Fragment } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Button, Form, Toast } from 'react-bootstrap'
import { IoMdCreate, IoIosAdd, IoIosClose, IoMdDoneAll, IoMdDownload } from "react-icons/io"

// Local imorts
import Loader from '../../components/Loader'
import ReactTable from '../../components/FilterTable'
import { fetchClients, addClient, editClient } from '../../actions/client/clientActions'
import getExcel from "../../_services/ExcelUtility";
import { Footer } from '../../components/Footer'

const ClientPage = ({ dispatch, loading, hasErrors, clients }) => {
    const fileName = 'Clients';
    const initialState = { Id: null, ClientName: "", ClientDescription: "", InActiveFlag: "Active" }
    const [client, setClient] = useState(initialState)
    const [dummyClient, setDummyClient] = useState(initialState)
    const [editDisabled, setEditDisabled] = useState(true)
    const [addDisable, setAddDisable] = useState(false)
    const [show, setShow] = useState(false)
    const [addSubmitDisabled, setSubmitAddDisabled] = useState(true)
    const [editing, setEditing] = useState(false)
    const [adding, setAdding] = useState(false)
    const [updating, setUpdating] = useState(true)
    const [validated, setValidated] = useState(false)
    const [showToaster, setShowToaster] = useState(false)
    const [updateErr, setUpdateErr] = useState(false)
    const [userName, setUserName] = useState("")
    const [clientNameError, setClientNameError] = useState(false)
    const [roleId, setRoleId] = useState(0)

    useEffect(() => {
        dispatch(fetchClients())
        if (localStorage.getItem("userData")) {
            const userData = localStorage.getItem("userData")
            setUserName(JSON.parse(userData).FirstName)
            setRoleId(JSON.parse(userData).RoleID)
        }
    }, [dispatch])

    const columns = [{
        Header: 'Actions',
        accessor: 'accessor',
        disableFilters: true,
        disableSortBy: true, width: 90,
        Cell: ({ row: { original } }) => (
            <Fragment>
                <Button variant="link" onClick={() => editClientHandler(original)} className="grid-action-btn" title="Edit Client">
                    <IoMdCreate className="icon" />
                </Button>
            </Fragment>
        )
    }, {
        Header: 'Client Name',
        accessor: 'ClientName',
        filter: 'ClientName',
        sortType: 'basic', width: 340
    }, {
        Header: 'Client Description',
        accessor: 'ClientDescription',
        filter: 'ClientDescription',
        sortType: 'basic', width: 452
    }, {
        Header: 'Status',
        accessor: 'InActiveFlag',
        filter: 'InActiveFlag',
        sortType: 'basic', width: 150
    }]

    const userColumns = [{
        Header: 'Client Name',
        accessor: 'ClientName',
        filter: 'ClientName',
        sortType: 'basic'
    }, {
        Header: 'Client Description',
        accessor: 'ClientDescription',
        filter: 'ClientDescription',
        sortType: 'basic'
    }, {
        Header: 'Status',
        accessor: 'InActiveFlag',
        filter: 'InActiveFlag',
        sortType: 'basic'
    }]

    // Add fn
    const addClientHandler = () => {
        setValidated(false)
        setClientNameError(false)
        setShow(true)
        setAddDisable(true)
        setValidated(false)
        setAdding(true)
    }

    // Trim values
    const trimValue = event => {
        const { name, value } = event.target
        setClient({ ...client, [name]: value.trim() })
    }

    const handleInputChange = event => {
        const { name, value } = event.target

        setClient({ ...client, [name]: value })
        
        setClientNameError(false)

        if (client.ClientName.length > 0 && client.ClientDescription.length > 0)
            setSubmitAddDisabled(false)
        else if (client.ClientName.length === 0 && client.ClientDescription.length === 0)
            setSubmitAddDisabled(true)
        else
            setSubmitAddDisabled(true)
    }

    const addClientSubmitHandler = (e) => {
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
        } else {
            e.preventDefault()
            if (clients.length > 0 && clients.find(item => item.ClientName === client.ClientName)) {
                setClientNameError(true)
            } else {
                setUpdating(false)
                if (client.InActiveFlag === "Active") {
                    client.InActiveFlag = "Y"
                } else {
                    client.InActiveFlag = "N"
                }
                const modifiedClient = { ...client, CreatedBy: userName, ModifiedBy: userName }
                dispatch(addClient(modifiedClient))
                setShowToaster(true)

                cancelHandler()
            }
        }
        setValidated(true)
        setSubmitAddDisabled(true)
    }

    // Edit fn
    const editClientHandler = (client) => {
        setShow(true)
        setEditing(true)
        setAddDisable(true)
        setUpdating(true)
        setValidated(false)
        setEditDisabled(false)

        setClient({
            Id: client.Id, ClientName: client.ClientName,
            ClientDescription: client.ClientDescription,
            InActiveFlag: client.InActiveFlag
        })
        setDummyClient({
            Id: client.Id, ClientName: client.ClientName,
            ClientDescription: client.ClientDescription,
            InActiveFlag: client.InActiveFlag
        })
    }

    // Update fn
    const handleEditInputChange = (e) => {
        const { name, value } = e.target

        setClient({ ...client, [name]: value })
        setUpdateErr(false)
        if (client.ClientName.length === 0 || client.ClientDescription.length === 0) {
            setEditDisabled(true)
        } else {
            setEditDisabled(false)
        }
    }

    const updateRow = (Id, updatedClient) => {
        // if (clients.length > 0 && clients.find(item => item.ClientName === client.ClientName)) {
        //     setClientNameError(true)
        //     setEditDisabled(true)
        //     setValidated(true)
        // } else 
        
        if (client.ClientName.length === 0 || client.ClientDescription.length === 0) {
            setValidated(true)
        }else {
            setEditing(false)
            if (updatedClient.InActiveFlag === "Inactive") {
                updatedClient.InActiveFlag = "Y"
            } else {
                updatedClient.InActiveFlag = "N"
            }
            const modifiedUpdatedClient = { ...client, ModifiedBy: userName }
            dispatch(editClient(modifiedUpdatedClient))

            setShowToaster(true)
            setEditDisabled(true)
            setUpdateErr(false)
            setEditing(false)
            setShow(false)
            setAddDisable(false)
            cancelHandler()
        }
    }

    const editClientSubmitHandler = (e) => {
        const form = e.currentTarget
        e.preventDefault()
        if (client.ClientName.length > 0 && client.ClientDescription.length > 0) {
            updateRow(client.Id, client)
        }else {
            if (form.checkValidity() === false) {
                e.preventDefault()
                e.stopPropagation()
            }else {
                // if(clientNameError){
                //     setUpdateErr(false)
                // }else{
                //     alert("Else")
                //     setUpdateErr(true)
                // }
                setUpdateErr(false)
                setEditDisabled(true)
            }
            setValidated(true)
        }
    }

    const cancelHandler = () => {
        dispatch(fetchClients())
        setShow(false)
        setSubmitAddDisabled(true)
        setAddDisable(false)
        setUpdateErr(false)
        setClient(initialState)
        setEditing(false)
        setAdding(false)
        setClientNameError(false)
    }

    return (
        <React.Fragment>
            <section className="content">
                <div className="page-title">
                    <h2 className="h2">{editing ? "Edit" : adding ? "Add" : null} Client</h2>
                    <div>
                    {editing ? null : adding ? null :
                        <Button onClick={() => addClientHandler()} disabled={addDisable}><IoIosAdd className="icon btn-icon" />Add Client</Button> 
                    }
                    {editing ? null : adding ? null :
                    <Button className="ml-2" onClick={() => getExcel(columns,clients,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button>
                    }
                    </div>
                    </div>

                {/* Toaster */}
                <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                    {/* <Toast.Header>
                        <img
                            src="holder.js/20x20?text=%20"
                            className="rounded mr-2"
                            alt=""
                        />
                        <strong className="mr-auto">Woohoo!!</strong>
                    </Toast.Header> */}
                    <Toast.Body>Successfully {updating ? "updated" : "added"} client.</Toast.Body>
                </Toast>

                <Row>
                    {show ?
                        <Col md={6}>
                            <div className="card pt-2">
                                <div className="card-body">
                                    <Form className="form" noValidate validated={validated} onSubmit={editing ? editClientSubmitHandler : addClientSubmitHandler}>
                                        {/* <h4 className="h4 mb-3">{editing ? "Edit Client" : "Add Client"}</h4> */}
                                        {updateErr ? <p className="text-center err-msg">Please change Name or Description or Status.</p> : null}
                                        <Form.Group>
                                            <Form.Label htmlFor="ClientName">Client Name<span className="required">*</span></Form.Label>
                                            <Form.Control type="text" required name="ClientName" min="2" maxLength="250" className={clientNameError ? 'is-invalid' : ''} isInvalid={clientNameError ? true : false} onBlur={trimValue} onChange={editing ? handleEditInputChange : handleInputChange} value={client.ClientName} />
                                            {clientNameError ?
                                                <Form.Control.Feedback type="invalid">Client name exists.</Form.Control.Feedback>
                                                :
                                                <Form.Control.Feedback type="invalid">Please enter client name.</Form.Control.Feedback>
                                            }
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label htmlFor="ClientDescription">Client Description<span className="required">*</span></Form.Label>
                                            <Form.Control as="textarea" type="text" required name="ClientDescription" min="2" maxLength="250" onBlur={trimValue} onChange={editing ? handleEditInputChange : handleInputChange} value={client.ClientDescription} />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter client description.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label htmlFor="InActiveFlag">Status</Form.Label>
                                            <Form.Control as="select" type="text" name="InActiveFlag" value={client.InActiveFlag} onChange={editing ? handleEditInputChange : handleInputChange}>
                                                <option>Active</option>
                                                <option>Inactive</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group className="text-right mt-4">
                                            {editing ?
                                                <Fragment>
                                                    <Button type="submit" disabled={editDisabled}><IoMdDoneAll className="icon btn-icon" />Update Client</Button>
                                                    <Button variant="danger" className="cancel-btn ml-3" onClick={() => cancelHandler()}><IoIosClose className="icon btn-icon" />Cancel</Button>
                                                </Fragment>
                                                :
                                                <Fragment>
                                                    <Button type="submit" disabled={addSubmitDisabled}><IoMdDoneAll className="icon btn-icon" />Submit</Button>
                                                    <Button variant="danger" className="cancel-btn ml-3" onClick={() => cancelHandler()}><IoIosClose className="icon btn-icon" />Cancel</Button>
                                                </Fragment>
                                            }
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Col>
                        :
                        <Col md={12}>
                            <div className="card pt-3 clients-grid-wrap">
                                <div className="card-body">
                                    {loading ? <Loader /> : hasErrors ? <p>Error occurred. Unable to load clients.</p> :
                                        <Fragment>
                                            {clients.length > 0 ?
                                                <ReactTable columns={roleId === 1 ? columns : userColumns} data={clients} page={5} defaultPageSize={10} />
                                                :
                                                <div className="no-data">No data found.</div>
                                            }
                                        </Fragment>
                                    }
                                </div>
                            </div>
                        </Col>
                    }
                </Row>
            
            <Footer />
            </section>
        </React.Fragment>
    )
}

// Map Redux state to React component props
const mapStateToProps = state => ({
    login: state.users.login,
    loading: state.clients.loading,
    clients: state.clients.clients,
    hasErrors: state.clients.hasErrors,
})

// Connect Redux to React
export default connect(mapStateToProps)(ClientPage)